import type { FaireProductEntity } from "../../entity_types/product";

export const p_v73v8ky4x6: FaireProductEntity = {
  token: "p_v73v8ky4x6",
  type: "product",
  name: "Star Crystal Nose Stud PB-050",
  brandToken: "b_pntx8vkece",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8182ceaeb9dc73217cbc1c98bfce2f26b69c008125675b9071075f7d550c940c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/824654588082e101d01262af5f3b2c423615d75121b80fe0b9d962a24b3dbb56.jpeg",
  ],
  priceDollars: 4.51,
  description:
    "Basic style nose stud, with a small crystal ball.\n\nMade of 316L Surgical Steel.\n\nBar thickness: 0.8 mm (20G)\n\nBar length: 7 mm\n\nCrystal Diameter: 3.0 mm.",
  tags: [],
  msrpDollars: 9.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:43.617Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
